































import { Vue, Component, Prop } from 'vue-property-decorator';
import MainButton from '@/shared/buttons/main-button.component.vue';

@Component({
  components: {
    MainButton,
  },
})
export default class EditModeButtonComponent extends Vue {
  @Prop({ type: String, required: true }) label!: string;

  @Prop({ type: Boolean, default: true }) isEditMode!: boolean;

  @Prop({ type: Boolean, default: true }) isEditable!: boolean;

  @Prop({ type: Boolean, default: false }) isAdministratorOrSupervisorOrGp!: boolean;

  get editModeText(): string {
    return this.isEditMode ? 'Editando' : 'Editar';
  }

  get editModeColor(): string {
    return this.isEditMode ? 'lightGreen' : 'lightBlue';
  }

  get editModeIcon(): string {
    return this.isEditMode ? 'Editando' : 'Editar';
  }

  emitClick() {
    this.$emit('click');
  }
}
